import React from "react";

const Sec = ({ id, titulo, children }) => (
  <section data-testid={`pp-secao-${id}`} className="mb-8">
    <h2 className="text-lg font-semibold text-teal-900 mb-2">{titulo}</h2>
    <div className="text-sm leading-relaxed text-slate-700 space-y-2">{children}</div>
  </section>
);

export default function PoliticaPrivacidade() {
  const atualizado = "Junho de 2026";
  return (
    <div data-testid="politica-privacidade-page" className="min-h-screen bg-slate-50">
      <header className="bg-teal-800 text-white">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <p data-testid="pp-marca" className="text-sm uppercase tracking-widest text-teal-200">Casa de Repouso São Jorge</p>
          <h1 className="text-3xl sm:text-4xl font-bold mt-1">Política de Privacidade</h1>
          <p className="text-teal-100 text-sm mt-2">Última atualização: {atualizado}</p>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <p data-testid="pp-intro" className="text-sm leading-relaxed text-slate-700 mb-8">
          Esta Política de Privacidade descreve como a <strong>Casa de Repouso São Jorge</strong> (&ldquo;nós&rdquo;)
          coleta, utiliza, armazena e protege os dados pessoais tratados por meio do seu sistema interno de gestão
          (&ldquo;Sistema&rdquo;), incluindo o envio de comunicações por WhatsApp e e-mail. Comprometemo-nos a tratar
          todos os dados em conformidade com a Lei Geral de Proteção de Dados (Lei nº 13.709/2018 &ndash; LGPD).
        </p>

        <Sec id="dados" titulo="1. Dados que coletamos">
          <p>Para prestar nossos serviços de acolhimento e a gestão administrativa e financeira, podemos tratar:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Dados dos residentes:</strong> nome, documentos, data de nascimento e informações assistenciais/clínicas necessárias ao cuidado.</li>
            <li><strong>Dados de familiares e responsáveis:</strong> nome, telefone, e-mail e grau de parentesco.</li>
            <li><strong>Dados financeiros:</strong> contratos, mensalidades, faturas e comprovantes de pagamento.</li>
            <li><strong>Dados de acesso ao Sistema:</strong> login, perfil de permissão e registros de uso.</li>
          </ul>
        </Sec>

        <Sec id="uso" titulo="2. Como utilizamos os dados">
          <ul className="list-disc pl-5 space-y-1">
            <li>Prestar e administrar os serviços de residência e cuidado ao idoso.</li>
            <li>Emitir e enviar faturas, avisos e comunicados aos responsáveis.</li>
            <li>Cumprir obrigações legais, contratuais e regulatórias.</li>
            <li>Garantir a segurança e o controle de acesso ao Sistema.</li>
          </ul>
        </Sec>

        <Sec id="whatsapp" titulo="3. Comunicações por WhatsApp e e-mail">
          <p>
            Utilizamos a <strong>WhatsApp Business Platform (Meta)</strong> e serviços de e-mail para enviar aos
            responsáveis mensagens estritamente relacionadas ao serviço, como <strong>faturas, lembretes de pagamento,
            avisos e comunicados</strong>. Essas mensagens são enviadas apenas para números e endereços fornecidos
            pelos próprios responsáveis no momento da contratação, mediante consentimento.
          </p>
          <p>
            Não enviamos mensagens de marketing não solicitadas. O responsável pode solicitar a interrupção do envio
            de comunicações a qualquer momento pelos canais de contato abaixo.
          </p>
        </Sec>

        <Sec id="compartilhamento" titulo="4. Compartilhamento de dados">
          <p>Não vendemos dados pessoais. Compartilhamos dados apenas com prestadores necessários à operação, entre eles:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Meta Platforms:</strong> para a entrega das mensagens via WhatsApp Business Platform.</li>
            <li><strong>Instituição financeira / processador de pagamentos:</strong> para emissão e conciliação de cobranças (boletos e faturas).</li>
            <li><strong>Autoridades públicas:</strong> quando exigido por lei ou ordem judicial.</li>
          </ul>
        </Sec>

        <Sec id="seguranca" titulo="5. Armazenamento e segurança">
          <p>
            Os dados são armazenados em ambiente controlado, com acesso restrito por perfil de permissão, autenticação
            e criptografia em trânsito. Mantemos os dados apenas pelo tempo necessário ao cumprimento das finalidades
            e das obrigações legais aplicáveis.
          </p>
        </Sec>

        <Sec id="direitos" titulo="6. Seus direitos (LGPD)">
          <p>Nos termos da LGPD, o titular pode solicitar: confirmação de tratamento, acesso, correção, anonimização,
          portabilidade, eliminação e informações sobre compartilhamento, além de revogar o consentimento a qualquer momento.</p>
        </Sec>

        <Sec id="contato" titulo="7. Contato">
          <p>
            Para exercer seus direitos ou esclarecer dúvidas sobre esta Política, entre em contato com a Casa de Repouso
            São Jorge pelos canais oficiais de atendimento informados no momento da contratação.
          </p>
        </Sec>

        <footer data-testid="pp-rodape" className="mt-10 pt-6 border-t border-slate-200 text-xs text-slate-500">
          © {new Date().getFullYear()} Casa de Repouso São Jorge. Todos os direitos reservados.
        </footer>
      </main>
    </div>
  );
}
